import React from 'react';
import { FlagStripe } from './FlagStripe';
export function Footer() {
  return <footer className="w-full bg-midnight" data-id="element-147">
      <FlagStripe thick data-id="element-148" />

      <div className="px-4 md:px-8 lg:px-16 py-12 md:py-16 max-w-7xl mx-auto" data-id="element-149">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8" data-id="element-150">
          <div data-id="element-151">
            <span className="font-heading font-bold text-ivory text-2xl md:text-3xl uppercase tracking-tight" data-id="element-152">
              XENOJOUEUR
            </span>
            <p className="font-body text-ivory/50 text-sm mt-2" data-id="element-153">
              AI-Powered iGaming Localization
            </p>
          </div>

          <div className="font-body text-ivory/50 text-sm space-y-1 md:text-right" data-id="element-154">
            <p data-id="element-155">Limassol, Cyprus</p>
            <p data-id="element-156">
              <a href="mailto:contact@xenojoueur.com" className="text-ivory/70 hover:text-ivory transition-colors duration-200 underline underline-offset-4" data-id="element-157">
                contact@xenojoueur.com
              </a>
            </p>
          </div>
        </div>

        <div className="border-t border-ivory/10 mt-8 pt-8" data-id="element-158">
          <p className="font-body text-ivory/30 text-xs uppercase tracking-wider" data-id="element-159">
            © 2026 Xenojoueur. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}